import { render } from "./Orderinfo.vue?vue&type=template&id=d6491ef8&scoped=true"
import script from "./Orderinfo.vue?vue&type=script&lang=js"
export * from "./Orderinfo.vue?vue&type=script&lang=js"

import "./Orderinfo.vue?vue&type=style&index=0&id=d6491ef8&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6491ef8"]])

export default __exports__